import PropTypes from 'prop-types'
import { RadioButton, CaretDown } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const ChoiceSurveyAnalytics = ({ type, sent, responses, responseRate }) => {
  const { t } = useTranslation(['surveys'])
  const typeIcon = type === 'single' ? <RadioButton size={20} /> : <CaretDown size={20} />
  return (
    <div className="ctp-survey__analytics-item">
      <div className="ctp-survey__analytics-header">
        {typeIcon}
        {t('surveys:analytics.choiceSurveys', { type: type.toUpperCase() })}
      </div>
      <div className="ctp-survey__analytics-col">
        <div className="ctp-survey__analytics-row">
          <div className="ctp-survey__analytics-col">
            <div className="ctp-survey__analytics-subtitle">{t('surveys:analytics.sent')}</div>
            <div className="ctp-survey__analytics-title">{sent}</div>
          </div>
          <div className="ctp-survey__analytics-col">
            <div className="ctp-survey__analytics-subtitle">{t('surveys:analytics.responses')}</div>
            <div className="ctp-survey__analytics-title">{responses}</div>
          </div>
        </div>
        <div className="ctp-survey__analytics-divider" />
        <div className="ctp-survey__analytics-row">
          <div className="ctp-survey__analytics-subtitle">
            {t('surveys:analytics.responseRate')}
          </div>
          <div className="ctp-survey__analytics-title">{responseRate}</div>
        </div>
      </div>
    </div>
  )
}

export default ChoiceSurveyAnalytics

ChoiceSurveyAnalytics.propTypes = {
  type: PropTypes.string,
  sent: PropTypes.number,
  responses: PropTypes.number,
  responseRate: PropTypes.string,
}
